import * as React from "react";
import {Component } from "react";
import "./navigation.scss";

import {NavigationConfiguration} from "../../../config/navigation-configuration";
import {UiState} from "../../../core/ui-state";
import {AppState} from "../app-mobx";
import {AppConfiguration} from "../../../core/config/app-configuration";


export interface BreadcrumbsProps {
    config: NavigationConfiguration;
    handleNavigation: (route: string) => void;
    uiStore: UiState;
    appStore: AppState;
    appConfig: AppConfiguration;
}

export class Breadcrumbs extends Component<BreadcrumbsProps, any> {
    uiStore: UiState;
    appStore: AppState;
    constructor(props: BreadcrumbsProps) {
        super(props);
        this.uiStore = this.props.uiStore;
        this.appStore = this.props.appStore;
        this.state = {
            search: null
        };
    }
    handleLocalUrl(event: React.MouseEvent): void {
        event.preventDefault();
        this.props.handleNavigation((event.target as HTMLAnchorElement).pathname);
    }
    render(): React.ReactElement | null {
        const {config, appConfig} = this.props;
        const addItems = this.appStore.breadcrumbs.items;
        const naviItems: React.ReactElement[] = [];
        let itemCount = 0;
        config.items.forEach((element) => {
            let innerElement: React.ReactElement;
            let href = element.href;
            // prepend basename if local url
            if (element.href && /^\/(\w|$)/.test(element.href)) {
                href = appConfig.basename + element.href;
                href = href.replace("//", "/");
                innerElement = (
                    <a href={href} target={element.target} className="breadcrumb__link"
                        onClick={(event: React.MouseEvent<HTMLAnchorElement>) =>
                            this.handleLocalUrl(event)}>{element.title}</a>
                );
            } else {
                innerElement = (
                    <a href={href} target={element.target} className="breadcrumb__link">{element.title}</a>
                );
            }
            naviItems.push(<li className="breadcrumb__list-entry parent" key={"breadcrumbs-" + itemCount}>
                {innerElement}
            </li>);
            itemCount++;
        });
        if (typeof addItems !== "undefined"
            && addItems.length > 0) {
            addItems.forEach((element) => {
                let innerElement: React.ReactElement;
                if (element.href) {
                    let href = element.href;
                    // prepend basename if local url
                    if (/^\/(\w|$)/.test(element.href)) {
                        href = appConfig.basename + element.href;
                        href = href.replace("//", "/");
                    }
                    innerElement = (
                        <a href={href} target={element.target} className="breadcrumb__link">{element.title}</a>
                    );
                } else {
                    innerElement = (<span className="breadcrumb__link">{element.title}</span>);
                }
                naviItems.push(<li className="breadcrumb__list-entry parent" key={"breadcrumbs-" + itemCount}>
                    {innerElement}
                </li>);
                itemCount++;
            });
        }
        return(
            <div className="breadcrumb-section">
                <div className="breadcrumb">
                    <ul className="breadcrumb__list">
                        {naviItems}
                    </ul>
                </div>
            </div>
        );
    }
}
